var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Select } from '@/components/ui/Form/Select';
/**
 * Select コンポーネントを Field コンポーネントに対応した形に変換
 * @param props
 * @returns
 */
export const SelectFieldBase = (props) => {
    const { input, meta } = props, selectProps = __rest(props, ["input", "meta"]);
    const { name, value } = input, restInput = __rest(input, ["name", "value"]);
    const { dirtySinceLastSubmit, error, submitError, touched } = meta;
    const isError = ((submitError && !dirtySinceLastSubmit) || error) && touched;
    return (_jsx(Select, Object.assign({}, selectProps, restInput, { isError: isError, name: name, value: value })));
};
